interface DefaultRouteObject {
    intent: null;
    action: null;
    storefront: string | undefined;
    language: string | null;
}

export function createDefaultRoutingObject(
    initialUrl: string,
): DefaultRouteObject {
    const { pathname, searchParams } = new URL(initialUrl);

    // Expects /xx/ or /xx-xx/ format in pathname.  /s/, /sff/, /sf-s/, /s-s/, etc. will not return a value.
    const regex = /^\/([A-Za-z]{2})(-[A-Za-z]{2})?\//;
    const pathSF = regex.exec(pathname);

    return {
        intent: null,
        action: null,
        storefront: pathSF?.[0]
            .substring(1, pathSF[0].lastIndexOf('/'))
            .toLowerCase(),
        language: searchParams.get('l'),
    };
}
